export const apiBaseUrlClean = 'api.dev.fullscale.rs';

export const environment = {
  production: false,
  apiBaseUrl: `https://${apiBaseUrlClean}`,
  version: '1.0.0',
};
